import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
//import VueAxios from "vue-axios";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./utils/pxtorem";
// table滚动插件
import elTableInfiniteScroll from "el-table-infinite-scroll";
Vue.use(elTableInfiniteScroll);
import "default-passive-events"; // 防止滚动报错，谷歌更新
import "@/assets/css/index.scss";
//分页组件
import Pagination from '@/components/pagination/index.vue'
Vue.component('Pagination', Pagination)
// 导入封装的组件
import memberInfo from "./components/memberInfo/index.vue";
import rightcard from "./components/rightcard/index.vue";
import table from "./components/table/index.vue";
import rightcards from "./components/rightcards/index.vue";
import navtop from "@/components/navtop/index.vue";
import leftNav from "@/components/nav/index.vue";
import { VueJsonp } from "vue-jsonp";
import Editor from "@/components/Editor";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "c6xg7ee1uiq8wjYTZOQBjyfcu8iCvSj0",
});
Vue.use(VueJsonp);
// 导入会员管理中的组件
// import dialog from "./views/Management-list/adjustment/components/dialog.vue";
// 使用封装的组件
Vue.component("MemberInfo", memberInfo);
Vue.component("RightCard", rightcard);
Vue.component("Table", table);
Vue.component("Rightcards", rightcards);
Vue.component("NavTop", navtop);
Vue.component("LeftNav", leftNav);
Vue.component("Editor", Editor);
// 使用会员管理中的组件
// Vue.component("Dialog", dialog);
// 使用element-ui
Vue.use(ElementUI);
// 使用axios
// Vue.use(VueAxios);
Vue.prototype.axios = axios;
Vue.config.productionTip = false;
// 定义全局时间过滤器
Vue.filter("dateFormat", function (timestamp) {
  let a = new Date(timestamp).getTime();
  const date = new Date(a);
  const Y = date.getFullYear() + "-";
  const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "  ";
  const h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  const m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
  const s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); // 秒
  const dateString = Y + M + D + h + m + s;
  // console.log('dateString', dateString); // > dateString 2021-07-06 14:23:00
  return dateString;
});
Vue.filter("dateFormats", function (timestamp) {
  let a = new Date(timestamp).getTime();
  const date = new Date(a);
  const Y = date.getFullYear() + "-";
  const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "  ";
  const dateString = Y + M + D;
  return dateString;
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
